import { usePage } from "@inertiajs/react"
import { useEffect } from "react"

import {
  captureDetailsReady,
  emailCaptureTokenFromUrl,
  emailCapturedSearchWithoutToken,
  isQuizSlug,
  notedQuizEmailCaptureDetails,
  quizSlugFromPath,
  recordQuizEmailCapture,
} from "@/lib/quiz-email-capture"
import { trackGoal } from "@/lib/track-goal"

const RETRY_MS = 250
const MAX_ATTEMPTS = 20

export function useQuizEmailCapture() {
  const page = usePage()
  const capture = page.props.email_capture
  const token = capture?.token ?? emailCaptureTokenFromUrl(page.url) ?? null
  const pathQuiz = quizSlugFromPath(page.url)
  const quiz =
    capture?.quiz && isQuizSlug(capture.quiz) ? capture.quiz : pathQuiz

  useEffect(() => {
    if (!token || !quiz) return

    const startedAt = performance.now()
    let attempts = 0
    let timer = 0

    const finish = () => {
      const nextSearch = emailCapturedSearchWithoutToken(window.location.search)
      if (nextSearch === null) return
      const nextUrl = `${window.location.pathname}${nextSearch}${window.location.hash}`
      window.history.replaceState(window.history.state, "", nextUrl)
    }

    const tick = () => {
      const noted = notedQuizEmailCaptureDetails()
      if (!captureDetailsReady(quiz, noted, performance.now() - startedAt)) {
        timer = window.setTimeout(tick, 50)
        return
      }

      attempts += 1
      const matching = noted?.quiz === quiz ? noted : null
      const status = recordQuizEmailCapture({
        token,
        quiz,
        score: matching?.score,
        tier: matching?.tier,
        track: trackGoal,
      })

      if (status === "sent" || status === "already") {
        finish()
        return
      }

      if (status === "unavailable" && attempts < MAX_ATTEMPTS) {
        timer = window.setTimeout(tick, RETRY_MS)
      }
    }

    timer = window.setTimeout(tick, 0)
    return () => window.clearTimeout(timer)
  }, [quiz, token])
}
